import { render, staticRenderFns } from "./DynamicMarquee.vue?vue&type=template&id=e74ad956&scoped=true&"
import script from "./DynamicMarquee.vue?vue&type=script&lang=js&"
export * from "./DynamicMarquee.vue?vue&type=script&lang=js&"
import style0 from "./DynamicMarquee.vue?vue&type=style&index=0&id=e74ad956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74ad956",
  null
  
)

export default component.exports